import { Link } from "react-router-dom";

const CATEGORIES = [
  {
    icon: "ri-film-line",
    title: "高清电影",
    desc: "修复版影片资料",
    to: "/category",
    accent: true,
  },
  {
    icon: "ri-book-open-line",
    title: "剧情介绍",
    desc: "分段剧情与看点",
    to: "/detail/se-jie",
  },
  {
    icon: "ri-user-star-line",
    title: "演员资料",
    desc: "主创与角色档案",
    to: "/detail/se-jie",
  },
  {
    icon: "ri-newspaper-line",
    title: "相关资讯",
    desc: "幕后与影展动态",
    to: "/news",
  },
  {
    icon: "ri-movie-2-line",
    title: "纪录片",
    desc: "人文与自然影像",
    to: "/category",
  },
  {
    icon: "ri-search-eye-line",
    title: "悬疑犯罪",
    desc: "高口碑类型片",
    to: "/category",
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-10 md:px-6 md:py-12">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <p className="font-label text-[11px] font-medium uppercase tracking-[0.24em] text-accent-600">
              Quick Access
            </p>
            <h2 className="mt-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
              分类快捷入口
            </h2>
          </div>
          <Link
            to="/category"
            className="hidden items-center gap-1 whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-accent-600 sm:flex"
          >
            全部影视分类
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="no-scrollbar -mx-4 flex gap-3 overflow-x-auto px-4 pb-1 md:mx-0 md:grid md:grid-cols-3 md:overflow-visible md:px-0 lg:grid-cols-6">
          {CATEGORIES.map((item) => (
            <Link
              key={item.title}
              to={item.to}
              className={`group flex min-w-[148px] flex-col rounded-lg border p-4 transition-colors duration-300 md:min-w-0 ${
                item.accent
                  ? "border-accent-200 bg-accent-50 hover:border-accent-400"
                  : "border-background-200 bg-background-50 hover:border-primary-300"
              }`}
            >
              <span
                className={`flex h-10 w-10 items-center justify-center rounded-md ${
                  item.accent ? "bg-accent-500 text-background-50" : "bg-primary-50 text-primary-600"
                }`}
              >
                <i className={`${item.icon} text-[20px]`} />
              </span>
              <h3 className="mt-3 whitespace-nowrap font-heading text-sm font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-1 whitespace-nowrap text-[11px] text-foreground-500">{item.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}